import { useState } from "react";
import { Warehouse } from "lucide-react";
import { cn } from "@/lib/utils";

const LOGO_SRC = "/kcss-logo.png";
export const BRAND_NAME = "KCSS OPS";

export const Brand = ({ subtitle, variant = "header", className }) => {
  const [err, setErr] = useState(false);

  if (variant === "auth") {
    return (
      <div className={cn("flex flex-col items-center gap-2 mb-8", className)} data-testid="brand-auth">
        {err ? (
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-lg bg-slate-900 text-white flex items-center justify-center">
              <Warehouse className="h-6 w-6" />
            </div>
            <h1 className="font-display font-bold text-xl text-slate-900">{BRAND_NAME}</h1>
          </div>
        ) : (
          <img src={LOGO_SRC} alt={BRAND_NAME} onError={() => setErr(true)} className="h-16 w-auto object-contain" />
        )}
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="brand-header">
      {err ? (
        <>
          <div className="h-9 w-9 rounded-md bg-slate-900 text-white flex items-center justify-center shrink-0">
            <Warehouse className="h-5 w-5" />
          </div>
          <div>
            <h1 className="font-display font-bold text-base text-slate-900 leading-none">{BRAND_NAME}</h1>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
        </>
      ) : (
        <>
          <img src={LOGO_SRC} alt={BRAND_NAME} onError={() => setErr(true)} className="h-11 w-auto object-contain" />
          {subtitle && <p className="text-xs text-slate-500 hidden md:block border-l border-slate-200 pl-3">{subtitle}</p>}
        </>
      )}
    </div>
  );
};
